import { DeviceToUpdate } from './../store/device';
import axios, { AxiosResponse } from 'axios';

import { apiUrl } from '@/config/api';

import { ApiDeviceList, ApiDeviceDates, ApiDeviceRoutes, ApiDeviceLayers, ApiDeviceActions } from './types/device';

const list = (token: string): Promise<AxiosResponse<ApiDeviceList>> => {
    return axios.post(
        `${apiUrl}/trk/tracking/device/detail/list`,
        {
            loadCurrentGeofences: true,
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        },
    );
};

const dates = (token: string, deviceId: number): Promise<AxiosResponse<ApiDeviceDates>> => {
    return axios.post(
        `${apiUrl}/trk/tracking/device/position/dates`,
        {
            deviceId,
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        },
    );
};

const routes = (token: string, deviceId: number, fromDate: Date): Promise<AxiosResponse<ApiDeviceRoutes>> => {
    return axios.post(
        `${apiUrl}/trk/tracking/device/position/routes`,
        {
            deviceId,
            from: fromDate.toISOString(),
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        },
    );
};

const layers = (token: string): Promise<AxiosResponse<ApiDeviceLayers>> => {
    return axios.post(`${apiUrl}/trk/tracking/map-object/detail/list`, null, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
};

const fences = (token: string): Promise<AxiosResponse<ApiDeviceActions>> => {
    return axios.post(`${apiUrl}/trk/tracking/action/detail/list`, null, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
};

const exportSingle = (token: string, fromDate: string, deviceId: number): Promise<AxiosResponse<Blob>> => {
    return axios.post(
        `${apiUrl}/trk/tracking/report/kml/deviceroutes`,
        {
            deviceId: deviceId,
            from: fromDate,
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                responseType: 'blob',
            },
        },
    );
};

const exportAll = (token: string, fromDate: string): Promise<AxiosResponse<Blob>> => {
    return axios.post(
        `${apiUrl}/trk/tracking/report/kml/devicepositions`,
        {
            from: fromDate,
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                responseType: 'blob',
            },
        },
    );
};

const updateSingle = (token: string, data: DeviceToUpdate, id: number): Promise<AxiosResponse<Blob>> => {
    return axios.put(`${apiUrl}/trk/tracking/device/${id}`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
};
export default {
    list,
    dates,
    routes,
    layers,
    fences,
    exportSingle,
    exportAll,
    updateSingle,
};
